import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraControlledMedsSecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M41.7885 53H21.7727C20.4033 53 19.2927 51.8629 19.2927 50.4608L18.3516 17.6125L45.6256 19.2969L44.2669 50.5145C44.2377 51.8944 43.1363 52.9984 41.7885 52.9984V53Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M26.8077 40.3187C25.4194 39.1344 23.3564 39.3267 22.1998 40.748C21.0431 42.1694 21.2309 44.2816 22.6191 45.4659L27.7411 49.8351C29.1293 51.0194 31.1924 50.8271 32.349 49.4058C33.5057 47.9844 33.3179 45.8722 31.9297 44.6879L26.8077 40.3187Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M32.3487 49.4041C31.1918 50.8251 29.1293 51.0175 27.7398 49.8331L25.2983 47.7671L29.4866 42.6193L31.9281 44.6854C33.316 45.8698 33.504 47.9815 32.3471 49.4041H32.3487Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M36.0804 39.722L34.5388 46.3628C34.1209 48.1627 35.2073 49.9686 36.9653 50.3964C38.7233 50.8242 40.4871 49.7119 40.905 47.912L42.4466 41.2712C42.8644 39.4713 41.778 37.6654 40.0201 37.2376C38.2621 36.8098 36.4982 37.9221 36.0804 39.722Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M40.023 37.2412C41.7806 37.6686 42.8681 39.476 42.4491 41.2755L41.7282 44.4329L35.3618 42.8826L36.0827 39.7252C36.5002 37.9257 38.2654 36.8122 40.023 37.2412Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M45.9857 15.1567L18.1387 14.9706C17.6858 14.9675 17.3099 15.3255 17.2791 15.7876L17.0019 20.049C16.9695 20.5536 17.3608 20.9826 17.8552 20.9826H46.1443C46.6311 20.9826 47.0193 20.5678 46.9993 20.071L46.8344 15.9958C46.816 15.5289 46.4416 15.1599 45.9857 15.1567Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M44.0414 11.8701L20.492 11.0011C19.7526 10.9743 19.1041 11.4537 18.9732 12.1271L17.8965 17.6581H46.0793L45.4539 13.0671C45.363 12.4031 44.7654 11.8969 44.0414 11.8701Z'
        fill={spotIllustration.primary.fill}
      />
    </Svg>
  )
}
